<template>
	<div class="coverShow">
		<div class="heading">知情同意书</div>

		<div class="textarea">
			<div class="subTitle">亲爱的参与者：</div>

			<textarea v-model="localContent" placeholder="请输入知情同意书内容"></textarea>
		</div>

		<div class="signature">
			<div class="subTitle">请在下方矩形框内绘制签名</div>
			<div class="region"></div>
		</div>

		<div class="operation">
			<div class="cancel" @click="$emit('cancel')">取消</div>
			<div class="confirm" @click="confirm">保存</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ConsentForm',

		props: {
			content: {
				type: String,
				default: ''
			},
		},

		data() {
			return {
				localContent: this.content
			}
		},

		watch: {
			content(val) {
				this.localContent = val
			}
		},

		methods: {
			confirm() {
				this.$emit('confirm', this.localContent)
			}
		}
	}
</script>

<style scoped>
	.coverShow {
		padding: 15px;
		background: #fff;
		width: 100%;
	}
	.coverShow .heading {
		width: 100%;
		font-size: 19px;
		font-weight: 500;
		color: #323B5A;
		line-height: 1;
		text-align: center;
		margin-top: 10px;
	}
	.coverShow .textarea {
		margin-top: 15px;
	}
	.coverShow .subTitle {
		font-size: 14px;
		font-weight: 500;
		color: #2b2f36;
		line-height: 1;
	}
	.coverShow .textarea textarea {
		width: 100%;
		padding: 10px;
		box-sizing: border-box;
		border: 1px dashed #3a60ff;
		border-radius: 1px;
		margin-top: 10px;
		font-size: 14px;
		font-weight: 400;
		color: #333333;
		line-height: 20px;
		width: 100%;
		resize: none;
		min-height: 250px;
		height: auto;
	}
	.coverShow .signature {
		margin-top: 15px;
	}
	.coverShow .signature .region {
		width: 100%;
		background: #ffffff;
		border: 1px solid #dcdde0;
		border-radius: 4px;
		padding: 12px;
		box-sizing: border-box;
		margin-top: 11px;
		min-height: 200px;
	}
	.coverShow .operation {
		display: flex;
		justify-content: space-evenly;
		margin-top: 20px;
	}
	.coverShow .operation .cancel {
		width: 134px;
		height: 46.5px;
		line-height: 46.5px;
		color: #3a60ff;
		background-color: #ffffff;
		border: 1px solid #3a60ff;
		font-size: 15px;
		font-weight: 600;
		border-radius: 25px;
		text-align: center;
		cursor: pointer;
	}
	.coverShow .operation .confirm {
		width: 134px;
		height: 46.5px;
		line-height: 46.5px;
		color: #fff;
		background-color: #3a60ff;
		border: 1px solid #3a60ff;
		font-size: 15px;
		font-weight: 600;
		border-radius: 25px;
		text-align: center;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// src/components/ConsentRequiredDialog/index.vue